import API from '@/lib/API';
const RESOURCE_URL = '/material-requests';

export const materialRequestService = {
  createRequest: async (data) => {
    const response = await API.post(RESOURCE_URL, data);
    return response;
  },

  updateRequest: async (id, data) => {
    const response = await API.patch(`${RESOURCE_URL}/${id}`, data);
    return response;
  },

  getProjectRequests: async (projectId, page = 1, limit = 10) => {
    const response = await API.get(`${RESOURCE_URL}/project/${projectId}?page=${page}&limit=${limit}`);
    return response;
  },

  updateRequestStatus: async (id, status) => {
    const response = await API.put(`${RESOURCE_URL}/${id}/status`, { status });
    return response;
  },

  ownerApproveMaterialRequest: async (id) => {
    const response = await API.put(`${RESOURCE_URL}/${id}/owner-approve`);
    return response;
  },

  getRequestById: async (id) => {
    const response = await API.get(`${RESOURCE_URL}/${id}`);
    return response;
  },

  getAllRequests: async (page = 1, limit = 10, status, filters = {}) => {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('limit', String(limit));
    if (status && status !== 'all') params.set('status', status);
    if (filters.search?.trim()) params.set('search', filters.search.trim());
    if (filters.startDate) params.set('startDate', filters.startDate);
    if (filters.endDate) params.set('endDate', filters.endDate);
    if (filters.ownerView) params.set('ownerView', 'true');
    const response = await API.get(`${RESOURCE_URL}?${params.toString()}`);
    return response;
  },

  approveRequestLines: async (id, approvals) => {
    const response = await API.put(`${RESOURCE_URL}/${id}/approve-items`, { approvals });
    return response;
  },

  ownerApproveRequest: async (id) => {
    const response = await API.put(`${RESOURCE_URL}/${id}/owner-approve`);
    return response;
  },

  dispatchRequest: async (id, data = {}) => {
    const response = await API.put(`${RESOURCE_URL}/${id}/dispatch`, data);
    return response;
  },

  /** Field officer: mark one dispatched line as received on site. */
  receiveItem: async (requestId, itemIndex) => {
    const response = await API.post(`${RESOURCE_URL}/${requestId}/receive-item`, { itemIndex });
    return response;
  },

  /** Field officer: mark all dispatched lines in a request as received with photos and notes. */
  bulkReceiveRequest: async (requestId, { statusNotes, photos, receivedItemsQtys }) => {
    const formData = new FormData();
    if (statusNotes) formData.append('statusNotes', statusNotes);
    if (receivedItemsQtys) formData.append('receivedItemsQtys', JSON.stringify(receivedItemsQtys));
    if (photos && photos.length > 0) {
      photos.forEach(file => {
        formData.append('photos', file);
      });
    }
    const response = await API.post(`${RESOURCE_URL}/${requestId}/bulk-receive`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response;
  }
};
